import { useCityStore } from '@store/city';
import { useMemo } from 'react';

import { useProductsAuthFilters } from '@api/catalog';
import { useProductsFilters } from '@api/catalog/product';

import { useAuth } from '@context/auth';

import { fromRoubleToKopecks } from '@scripts/helpers';
import { useFiltersHelper } from '@scripts/hooks';

export const useCatalogFilters = (
    filters: any,
    { enabled = true, enabledAuth = true }: { enabled: boolean; enabledAuth: boolean }
) => {
    const { isAuthUser } = useAuth();

    const { initialValues: urlFilters } = useFiltersHelper({});

    const currentCity = useCityStore(({ currentCity }) => currentCity);

    const product_ids = urlFilters.product_ids;

    delete urlFilters.product_ids;
    delete urlFilters.category;
    delete urlFilters.categories;
    delete urlFilters.page;

    const price_gte = urlFilters?.filters?.price ? fromRoubleToKopecks(urlFilters.filters.price[0]) : null;
    const price_lte = urlFilters?.filters?.price ? fromRoubleToKopecks(urlFilters.filters.price[1]) : null;

    delete urlFilters?.filters?.price;

    const preparedFilters = {
        ...urlFilters?.filters,
        ...(price_gte && { price_gte }),
        ...(price_lte && { price_lte }),
    };

    const {
        data: filtersList,
        isLoading: isFiltersLoading,
        isFetching: isFilterFetching,
        isIdle: isIdleFilters,
    } = useProductsFilters(
        {
            ...(currentCity?.region_guid && {
                customer_region_guid: currentCity.region_guid,
            }),
            ...(filters !== null && {
                filter: {
                    ...filters,
                    ...(product_ids?.length > 0 && { id: product_ids }),
                    ...preparedFilters,
                },
            }),
        },
        enabled
    );

    const {
        data: filtersAuthList,
        isLoading: isFiltersAuthLoading,
        isFetching: isFiltersAuthFetching,
        isIdle: isIdleFiltersAuth,
    } = useProductsAuthFilters(
        {
            ...(currentCity?.region_guid && {
                customer_region_guid: currentCity.region_guid,
            }),
            ...(filters !== null && {
                filter: {
                    ...filters,
                    ...(product_ids?.length > 0 && { id: product_ids }),
                    ...preparedFilters,
                },
            }),
        },
        enabledAuth
    );

    const filtersListData = useMemo(
        () => (isAuthUser ? filtersAuthList?.data : filtersList?.data),
        [isAuthUser, filtersList, filtersAuthList]
    );

    return {
        filtersListData,
        isFiltersLoading,
        isIdleFilters,
        isFiltersAuthLoading,
        isIdleFiltersAuth,
        preparedFilters,
        isFilterFetching,
        isFiltersAuthFetching,
    };
};
